import { render, staticRenderFns } from "./AllExtensionsModal.vue?vue&type=template&id=2fc31776&"
import script from "./AllExtensionsModal.vue?vue&type=script&lang=js&"
export * from "./AllExtensionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports